import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileWordTwotoneStandard.js";
import i from "../components/PfIcon.js";
const o = (r, t) => {
  const e = {
    ...r,
    ...t.attrs
  };
  return a(i, n(e, {
    icon: d
  }), null);
};
o.displayName = "FileWordTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
